/**
 * Set opacity of rgb color
 * @param color RBG value
 * @param factor
 */
export const rgbOpacity = (color: string, factor: string) => {
    const [r, g, b, ..._tail] = color.substring(4, color.length - 1).split(',');
    return `rgb(${r},${g},${b},${factor})`;
};